import { jsx as _jsx } from "react/jsx-runtime";
import { FieldWrapper } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { useEffect, useRef, useState } from 'react';
import RichTextField from 'components/shared/util/richTextField/containers/richTextField';
import { useHookFormFieldWrapper, } from 'utils/hookForm';
import styles from './hookFormRichTextField.module.scss';
/**
 * Represents the React Hook Form variant of the {@link RichTextField} component.
 * todo: render templates with context and handle attachments
 */
export const HookFormRichTextField = (props) => {
    var _a, _b;
    const { controller, fieldWrapperProps } = useHookFormFieldWrapper(props);
    const [validationState, setValidationState] = useState({
        touched: false,
        valid: true,
    });
    const [text, setText] = useState('');
    const editorRef = useRef(null);
    const handleChange = () => {
        var _a;
        const plainText = (_a = editorRef === null || editorRef === void 0 ? void 0 : editorRef.current) === null || _a === void 0 ? void 0 : _a.getPlainText();
        if (plainText)
            setText(plainText);
    };
    useEffect(() => {
        controller.field.onChange(text);
        if (text && text != '') {
            setValidationState({ touched: true, valid: true });
        }
    }, [text]);
    return (_jsx(FieldWrapper, Object.assign({}, fieldWrapperProps, { children: _jsx(RichTextField, Object.assign({ id: props.name, ref: editorRef, className: classnames((_a = props.componentProps) === null || _a === void 0 ? void 0 : _a.className, styles.textArea), onChange: handleChange, validation: ((_b = props.componentProps) === null || _b === void 0 ? void 0 : _b.showCharacterLimit) ? validationState : undefined, setValidationState: setValidationState, stateBarClassName: styles.stateBar }, props.componentProps)) })));
};
